import React from 'react';
import {Link} from 'react-router-dom';

import './cards.styles.scss';

function htmlDecode (input) {
    return input.replace(/&#8217;/g, "’")
                .replace(/&#8216;/g, "‘")
                .replace(/&#8220;/g, "“")
                .replace(/&#8221;/g, "”")
                .replace(/&amp;/g, "&")
}

class Card extends React.Component {
    render(){
        if (this.props.caseStudyBoolean) {
            return (
                <li className="card">
                    <Link to={`/tourism-community-stories/${this.props.slug}`}>
                        <div className="img-wrapper">
                        <img src={this.props.image} alt={htmlDecode(this.props.title)}/>
                        </div>
                        <div className="content-wrapper">
                            <div className="title-description">
                                <h3>{htmlDecode(this.props.title)}</h3>
                                <p>{this.props.description}</p>
                            </div>
                            <div className="tags-wrapper">
                                <span className="content-tag">{htmlDecode(this.props.content)}</span>
                                <span className="industry-tag">{htmlDecode(this.props.industry)}</span>
                            </div>
                        </div>
                    </Link>
                </li>
            )
        }
        return (
            <li className="card">
                <a href={this.props.link} target="_blank" rel="noopener noreferrer">
                    <div className="img-wrapper">
                        <img src={this.props.image} alt={htmlDecode(this.props.title)}/>
                    </div>
                    <div className="content-wrapper">
                        <div className="title-description">
                            <h3>{htmlDecode(this.props.title)}</h3>
                            <p>{this.props.description}</p>
                        </div>
                        <div className="tags-wrapper">
                            <span className="content-tag">{htmlDecode(this.props.content)}</span>
                            <span className="industry-tag">{htmlDecode(this.props.industry)}</span>
                        </div>
                    </div>
                </a>
            </li>
        )
    }
}

export default Card;